var map = {
	"./5_rabbit.mp3": "d309",
	"./6_bear.mp3": "94d1",
	"./7_mole.mp3": "aa21",
	"./M_Brilliant.mp3": "8077",
	"./M_Excellent.mp3": "3b7a",
	"./M_Fantastic.mp3": "992a",
	"./M_Great.mp3": "d9af",
	"./M_Perfect.mp3": "50ad",
	"./M_Think again.mp3": "1110",
	"./M_Try again.mp3": "ea3a",
	"./M_Very good.mp3": "2dd9",
	"./M_Well done.mp3": "7b81",
	"./M_Work harder.mp3": "98a6",
	"./click.mp3": "ec4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90f6";